/** @format */

import React from "react";

const TableRow = ({ row, id, showActions, onProfileClick }) => {
  let statusClass = "";

  if (row.Status === "Approved") {
    statusClass =
      "bg-[#F6F6F6] text-[#20573D]  xs:w-14 md:w-20 m-2 md:py-0.5 border rounded-lg border-1 border-[#BBDBCA] flex items-center justify-center text-xs font-medium";
  } else if (row.Status === "Pending") {
    statusClass =
      "bg-[#FFF9F2] text-[#734011] xs:w-14 md:w-20 m-2 md:py-0.5 border border-1  border-[#EECEB0] flex items-center justify-center rounded-lg text-xs font-medium";
  } else if (row.Status === "Disapproved") {
    statusClass =
      "bg-[#FFF4F2] text-[#CB3A31]  w-20 md:w-24  m-2 md:py-0.5 md:px-1.5 border  border-1  border-[#EEB4B0] flex items-center justify-center rounded-lg text-xs font-medium";
  } else {
    return null;
  }

  const handleClick = () => {
    onProfileClick(row.id);
  };

  return (
    <tr className="border-b-2" key={row.id}>
      <th className=" md:p-2 text-start text-[#404040] text-[10px] md:text-sm font-normal">
        {row.id}
      </th>
      <td
        className=" md:p-2 text-start text-[#404040] text-[10px] md:text-sm font-normal"
        onClick={handleClick}
      >
        {row.Name}
      </td>
      <td className=" md:p-2 text-start text-[#404040] text-[10px] md:text-sm font-normal">
        {row.Date}
      </td>
      <td className=" md:p-2 text-start text-[#404040] text-[10px] md:text-sm font-normal">
        {row.Officer}
      </td>
      <td
        className={` md:p-2 text-start text-[10px] md:text-sm  font-normal w-2 ${statusClass}`}
      >
        {row.Status}
      </td>
      {showActions && (
        <td className=" md:p-2 text-start text-[10px] md:text-sm font-normal text-[#4C4DDC]">
          {row.Action}
        </td>
      )}
    </tr>
  );
};

export default TableRow;
